<div class="just-for-you-master-filter section">
    <div class="j4u-master-filters" id="j4uMasterFilters">
        <ng-container *ngIf="filtersData && filtersData?.showClearAllFilters">
            <div class="j4ufilters-header">
                <span role="heading" aria-label="Filters heading" aria-level="2" class="j4ufilters-heading">Filters</span>
                <span role="button" aria-label="Clear all filters" tabindex="0" class="j4ufilters-clear"
                    (click)="clearAllFilters($event)" (keydown)="clearAllFilters($event)">Clear all</span>
            </div>
        </ng-container>
        <ng-container>
            <div class="coupon-filter-container just-for-you-{{data.property}}-filter d-none d-lg-block" *ngFor="let data of filtersData?.data"
              style="border-bottom-style: none">
                <div class="card filter-panel coupon-filter-panel">
                    <div id="coupon{{data.property}}FilterDropdown" class="filter-collapse">
                        <div class="card-header card-bg-none d-flex">
                            <div class="mr-auto">
                                <span class="card-title" attr.aria-label="{{data.label}}" role="heading" aria-level="2"
                                    >{{data.label}}</span>
                                <span (click)="clearFilter($event, data.label)"
                                    (keydown)="clearFilter($event, data.label)" [id]="'clear_' + data.property + '_filter'" role="button"
                                    tabindex="0" [attr.aria-label]="'Clear ' + data.label + ' filters'"
                                    class="clear-selection">Clear</span>
                                    <div class="sr-only" #clearStatus></div>
                            </div>
                            <!-- <span class="sr-only svg-icon"  tabindex="0" >{{toggleAccordion(data.property) ? 'collapsed' :"expand"}}</span> -->
                            <span data-toggle="collapse" class="svg-icon svg-icon-Arrow_up position-relative mt-0" [ngClass]="selectedFilterType[data.property] ? 'collapsed' : ''"
                                [attr.aria-label]="'Filter by ' + data.label"
                                [attr.aria-expanded]="!selectedFilterType[data.property]"
                                [attr.aria-controls]="'filter_by_coupon_' + data.property"
                                (click)="toggleAccordion(data.property)"
                                (keydown)="onAccordionKeydown($event, data.property)"
                                role="button" tabindex="0"></span>
                        </div>
                    </div>
                </div>

                <div id="filter_by_coupon_{{data.property}}" class="just-for-you-{{data.property}}-filter filtering-area collapse"
                    [ngClass]="!selectedFilterType[data.property] ? 'show': '' " >
                    <label class="filter-option" *ngFor="let couponCategory of data?.values; let i = index"
                        [ngClass]="{'active' : true, 'selected' : couponCategory.name}">
                        <label class="squaredThree">
                            <input type="checkbox" role="checkbox" id="{{couponCategory.name}}"
                                [checked]="isChecked(couponCategory.name, data.label)"
                                [attr.aria-checked]="isChecked(couponCategory.name, data.label) ? 'true' : 'false'"
                                (change)="onCheckEvent($event, couponCategory.name, data.label, data.property)">
                            {{couponCategory.name}} {{ couponCategory.count ? '(' + couponCategory.count + ')' : ''}}
                            <br>
                            <span class="checkmark"></span>
                        </label>
                    </label>
                </div>
                <div *ngIf="data.displaySpacer" class="horizontal-spacer horizontal-spacer-filter"></div>
            </div>
        </ng-container>
    </div>

  <!-- Mobile Filter Button -->
  <div class="coupon-grid-container">
    <div class="sr-only" id="couponFilterMsg"></div>
    <div class="coupon-grid-mobile-filters d-block d-lg-none" style="top:16px">
      <div class="mobile-filters-heading" id="filters-heading-mobile" tabindex="0" role="button" data-toggle="modal" data-target="#exampleModal"
        (click)="displayFilters();" (keypress)="displayFilters();">
         <span class="svg-utility-filter-icon filter-icon" role="img"></span>
         <span class="filter-heading">Filters</span>
      </div>
      <!-- Mobile Filters Modal Start -->
      <div id="mobileFilters" class="modal mobile-filters" role="dialog" aria-modal="true" aria-labelledby="filter-heading"
        *ngIf="showFilters">
         <div class="mobile-filters-control">
             <div class="mobile-filters-control-left">
                 <span id="filter-heading" class="mobile-filter-control-title" aria-label="Filters panel"  role="heading" tabindex="0" data-tabIndex="first">Filters</span>
                 <a id="clear-all" class="mobile-filter-controll-clear-all"
                     aria-label="Clear all filters" role="link" tabindex="0"
                     (click)="clearAllFilters($event)" (keypress)="clearAllFilters($event)">Clear All</a>
             </div>
             <div class="mobile-filters-control-right">
                 <div class="apply-button">
                     <span id="filter-apply" role="button" tabindex="0" 
                      (click)="applyAllFilters()" (keypress)="applyAllFilters()">Apply</span>
                 </div>
             </div>
         </div>
         <div class="mobile-filters-sections">
          <!-- Start Mobile Filters Loop through filterData-->
          <ng-container>
            <div *ngFor="let data of filtersData?.data" class="coupon-filter-container just-for-you-{{data.property}}-filter d-lg-block">
                <div class="card filter-panel coupon-filter-panel">
                    <div id="coupon{{data.property}}FilterDropdown_mobile" class="filter-collapse">
                        <div class="card-header card-bg-none d-flex flex-column">
                            <div>
                            <span [id]="'filterTitle_' + data.property" class="card-title"
                                [attr.aria-label]="'Filter by ' + data.label">{{data.label}}</span>
                            <span (click)="clearFilter($event, data.label)"
                                (keydown)="clearFilter($event, data.label)" [id]="'clear_' + data.property + '_filter_mobile'" role="button"
                                tabindex="0" [attr.aria-label]="'Clear ' + data.label + ' filters'"
                                class="clear-selection">Clear</span>
                            </div>
                            <span class="svg-icon svg-icon-Arrow_up mt-0" (click)="toggleAccordion(data.property)" [ngClass]="!selectedFilterType[data.property] ? '' : 'collapsed'"
                            [attr.aria-expanded]="!selectedFilterType[data.property]" [attr.aria-controls]="'filter_by_coupon_' + data.property + '_mobile'" (keydown)="onAccordionKeydown($event, data.property)"
                            role="button" tabindex="0" [attr.aria-label]="'Filter by ' + data.label"></span>
                            <!-- <a data-toggle="collapse" class="svg-icon svg-icon-Arrow_up mt-0" [ngClass]="toggleAccordion(data.property) ? '' : 'collapsed'"
                                (click)="toggleAccordion(data.property)" (keyboard.enter)="toggleAccordion(data.property)" role="button" [attr.aria-expanded]="accordianIsExpanded" tabindex="0"
                                attr.aria-label="{{data.label}} filters section" href="#filter_by_coupon_{{data.property}}"></a> -->
                        </div>
                    </div>
                </div>

                <div id="filter_by_coupon_{{data.property}}_mobile" class="filtering-area"
                    [collapse]="selectedFilterType[data.property]">
                    <ng-container *ngIf="filtersData?.displayLimitedFilters && displayLimitedCategories(data); else displayAllFilters">
                      <label class="filter-option" *ngFor="let couponCategory of data?.values; let i = index"
                          [ngClass]="{'active' : isChecked(couponCategory.name, data.label), 'selected' : isChecked(couponCategory.name, data.label)}">
                          <ng-container *ngIf="i < countToDisplayShowMoreButton">
                          <label class="squaredThree">
                              <input type="checkbox" role="checkbox" [id]="couponCategory.name + '_mobile'"
                                  [checked]="isChecked(couponCategory.name, data.label)"
                                  [attr.aria-checked]="isChecked(couponCategory.name, data.label) ? 'true' : 'false'"
                                  (change)="onCheckEvent($event, couponCategory.name, data.label, data.property)">
                                  {{couponCategory.name}} {{ couponCategory.count ? '(' + couponCategory.count + ')' : ''}}
                              <br>
                              <span class="checkmark"></span>
                          </label>
                        </ng-container>
                      </label>
                    </ng-container>
                    <ng-template #displayAllFilters>
                      <label class="filter-option" *ngFor="let couponCategory of data?.values; let i = index"
                          [ngClass]="{'active' : isChecked(couponCategory.name, data.label), 'selected' : isChecked(couponCategory.name, data.label)}">
                          <label class="squaredThree">
                              <input type="checkbox" role="checkbox" [id]="couponCategory.name + '_mobile'"
                                  [checked]="isChecked(couponCategory.name, data.label)"
                                  [attr.aria-checked]="isChecked(couponCategory.name, data.label) ? 'true' : 'false'"
                                  (change)="onCheckEvent($event, couponCategory.name, data.label, data.property)">
                              {{couponCategory.name}} {{ couponCategory.count ? '(' + couponCategory.count + ')' : ''}}
                              <br>
                              <span class="checkmark"></span>
                          </label>
                      </label>
                    </ng-template>
                </div>
                <div class="mobile-filters-show-more" *ngIf="filtersData?.displayLimitedFilters && accordianIsExpanded">
                  <div class="showMoreBtn" *ngIf="data?.values.length > countToDisplayShowMoreButton">  
                      <a href="javascript:void(0)" [attr.aria-label]="!isShowMoreButtonClicked ? 'Show more filters' : 'Show less filters'" role="link" class="links__action underline word-highlight-sm" (click)="toggleDisplayOfCategories()" (keypress.enter)="toggleDisplayOfCategories()">{{!isShowMoreButtonClicked ? showMoreButtonTextForNonDesktop : showLessButtonTextForNonDesktop}}</a>
                  </div>
                </div>
                <div *ngIf="data.displaySpacer" class="horizontal-spacer horizontal-spacer-filter"></div>
            </div>
        </ng-container>
         </div>
     </div>
    </div>
  </div>
</div>
